import { render, staticRenderFns } from "./AddPatientForm.vue?vue&type=template&id=9389b59e&"
import script from "./AddPatientForm.vue?vue&type=script&lang=js&"
export * from "./AddPatientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports